import { cardListClass } from "@/components/threads/shared.tsx";
import { groupMemoriesByDate } from "@/shared/memory/grouping.ts";
import { useMemo } from "react";
import { MemoryItem } from "./MemoryItem.tsx";
import type { Memory } from "./types.ts";

export const MemoryList = ({
  memories,
  isAdmin = false,
}: {
  memories: Memory[];
  isAdmin?: boolean;
}) => {
  const groupedMemories = useMemo(() => groupMemoriesByDate(memories), [memories]);

  return (
    <div className="flex flex-col gap-6">
      {groupedMemories.map(([bucket, bucketMemories]) => (
        <div key={bucket} className="flex flex-col gap-2">
          <h3 className="text-sm font-medium text-muted-foreground">{bucket}</h3>
          {/* The shared card gutter, not a local one: this list is grouped by
              date, so its cards sit in the group container rather than the
              outer wrapper, and it was the one list still spacing them at 16px
              while every other card list used 12px. */}
          <div className={cardListClass}>
            {bucketMemories.map((memory) => (
              <MemoryItem key={memory.id} memory={memory} isAdmin={isAdmin} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};
